export default __webpack_public_path__ + "static/O0229-d3687de27180d91d9ae2d07a8e918306.png";